export default "__VITE_ASSET__CiEmaJ7c__"